import React, { FC } from 'react';
import styles from './ParkingProjectCard.module.css';
import Features from '../Features/Features';
import Button from '../UI/Button/Button';
import Icon from '../Icon';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames'

interface ParkingProjectCardProps {
  title: string;
  description: string;
  features: { id: number; text: string; image?: string }[];
  image?: string;
  preview: string;
  paddingVariant?: 'default' | 'large';
  project: number;
  parkingCount: number;
  minPrice?: number;
}

const getDeclension = (number: number, one: string, few: string, many: string): string => {
  const mod10 = number % 10;
  const mod100 = number % 100;

  if (mod100 >= 11 && mod100 <= 14) {
    return many;
  }
  if (mod10 === 1) {
    return one;
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return few;
  }
  return many;
};

const ParkingProjectCard: FC<ParkingProjectCardProps> = ({
  title,
  description,
  features,
  image,
  preview,
  paddingVariant = 'default',
  project,
  parkingCount
}) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/parking/status');
  };

  return (
    <div
      className={cn(styles.card, styles[`padding_${paddingVariant}`] || '')}
    >
      <div className={styles.inner}>
        <div className={styles.main_wrapper}>
          <img src={preview} className={styles.preview_image} alt='Изображение проекта' />
          <Features features={features} alignment="side" cardColor="black" />
          <div className={styles.header_wrapper}>
            {image ? (
              <img src={image} alt={title || description} className={styles.logo_title} />
            ) : (
              title && <h2 className={styles.title}>{title}</h2>
            )}
            <p className={cn('text_body_b1', styles.description)}>{description}</p>
            <Button
              colorType="bw"
              roundType="small_rounded"
              icon={
                <Icon name="iconMoreInfo" width="16" height="16" fill="#fff" />
              }
              onClick={handleButtonClick}
            >
              {`${parkingCount} ${getDeclension(parkingCount, 'машиноместо', 'машиноместа', 'машиномест')}`}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParkingProjectCard;